import React, { useLayoutEffect, useRef, useEffect, useState } from "react"
import VisibilitySensor from 'react-visibility-sensor'
import { gsap } from "gsap";
import useWindowSize from "../components/hooks"
import "../components/winter-svg.scss"
import "../components/pages.scss"
import { StaticImage } from "gatsby-plugin-image"
import winterMobileHeader from "../images/Winter_Mobile_Header.svg"

export default function WinterSVG() {
	const [desktopViewState, setDesktopViewState] = useState(null);
	const winterItems = useRef([]);
	const winterSVG = useRef();
	const [summerInt, setSummerInt] = useState(null);
	const accordionItem = useRef([]);
	const [accordInt, setAccordInt] = useState({currentOpen: null, prevOpen: null, open: false});
	const triggers = useRef([]);
	const size = useWindowSize();

    useEffect(() => {
		const mql = window.matchMedia('(min-width: 1024px)');
		setDesktopViewState(mql.matches);
	}, [size, desktopViewState]);

    useEffect(() => {
    	let q = gsap.utils.selector(winterSVG.current);
    	let tl = gsap.timeline()
    	.set(q(".text"), {display: 'none'})
    	.set(q(".rings"), {display: 'none', opacity: 0})
    	.set(q(".center-icon"), {opacity: 0, scale: .6, transformOrigin: '50% 0%'})
    	.set(q(".summer-circle-item .summer-circle"), {scale: .85, transformOrigin: '50% 50%'})
    	.set(q(".summer-circle-item"), {opacity: 0})
    	.set(q(".icon-text"), {scale: 1, opacity: 1, transformOrigin: 'center center', duration: .5})

    	for(let x = 0; x < triggers.current.length; x++) {
    		let triggerParent = gsap.utils.selector(triggers.current[x]);
	    	let tl = gsap.timeline()
	    	.set(triggerParent(".rings"), {display: 'none', opacity: 0})
	    	.set(triggerParent(".icon"), {scale: .6, transformOrigin: '50% 0%'})
	    	.set(triggerParent(".summer-circle-item .summer-circle"), {scale: .9, transformOrigin: '50% 50%'})
	    	// .set(triggerParent(".summer-circle-item"), {opacity: 0})
	    	.set(triggerParent(".icon-text"), {scale: 1, opacity: 1, transformOrigin: 'center center', duration: .5})		
    	}
    	

    }, []); 

    function handleClickSummer(int) {
    	if(int === summerInt) {
    		closeSummerItem(null);
    		setSummerInt(null);
    	} else {
    		closeSummerItem(int);
    		openSummerItem(int);
    		setSummerInt(int);
    	}
    }

    function openSummerItem(int) {
    	let q = gsap.utils.selector(winterItems.current[int]);
    	let tl = gsap.timeline()
    	.set(winterItems.current[int], {zIndex: 15, pointerEvents: 'none'})
    	.to(q(".icon-text"), {scale: .5, opacity: 0, transformOrigin: 'center center', duration: .5})
		.to(q(".center-icon"), {scale: 1, transformOrigin: '50% 0%', duration: .5}, "-=.4")
		.to(q(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%'}, "-=.5")    	
		.to(q(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: 1, transformOrigin: '50% 50%'}, "-=.5")
		.fromTo(q(".text"), {opacity: 0, y: -60}, {display: 'block', y: 0, opacity: 1, ease: 'power4'}, "-=.6")
		.set(winterItems.current[int], {pointerEvents: 'auto'})
    }

    function closeSummerItem(int) {
    	let allItems = winterItems.current;
    	for(let x = 0; x < allItems.length; x++) {
    		if(x === int) { continue; }
    		let q = gsap.utils.selector(winterItems.current[x]);
    		let tl = gsap.timeline()
    		.set(winterItems.current[x], {zIndex: 10, pointerEvents: 'none'})
    		.to(q(".text"), {display: 'none', opacity: 0, y: -40, duration: .2})
    		.to(q(".rings"), {display: 'none', opacity: 0, rotate: 0,})
    		.to(q(".center-icon"), {scale: .6, transformOrigin: '50% 0%'}, "-=.5")
    		.to(q(".summer-circle-item .summer-circle"), {scale: .85, transformOrigin: '50% 50%'}, "-=.4")
    		.to(q(".icon-text"), {scale: 1, opacity: 1, transformOrigin: 'center center', duration: .5}, "-=.6")	
    		.set(winterItems.current[x], {zIndex: 10, pointerEvents: 'auto'})
    	}
    }

    // useEffect(() => {

    // }, [summerInt]);

    function onChange(isVisible) {
    	if(summerInt !== null) {
	    	closeSummerItem(null);
	    	setSummerInt(null);
	    }
    	console.log(isVisible, 'vis');
    	if(isVisible) {
    		let tl = gsap.timeline({paused: true})
    		let allItems = winterItems.current;
			let q1 = gsap.utils.selector(winterItems.current[3]);
			let q2 = gsap.utils.selector(winterItems.current[1]);
			let q3 = gsap.utils.selector(winterItems.current[0]);
			let q4 = gsap.utils.selector(winterItems.current[2]);
			let q5 = gsap.utils.selector(winterItems.current[4]);
			// let q6 = gsap.utils.selector(winterItems.current[5]);

    		tl.fromTo(q1(".summer-circle-item"), {opacity: 0, x: 40, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
    		.to(q1(".center-icon"), {opacity: 1}, "-=.5")    	
    		.to(q1(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q1(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.fromTo(q2(".summer-circle-item"), {opacity: 0, x: 20, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			.to(q2(".center-icon"), {opacity: 1}, "-=.5")    	
			.to(q2(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q2(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.fromTo(q3(".summer-circle-item"), {opacity: 0, x: 10, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			.to(q3(".center-icon"), {opacity: 1}, "-=.5")    	
			.to(q3(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q3(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.fromTo(q4(".summer-circle-item"), {opacity: 0, x: -10, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			.to(q4(".center-icon"), {opacity: 1}, "-=.5")    	
			.to(q4(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q4(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.fromTo(q5(".summer-circle-item"), {opacity: 0, x: -20, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			.to(q5(".center-icon"), {opacity: 1}, "-=.5")    	
			.to(q5(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			.to(q5(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			// tl.fromTo(q6(".summer-circle-item"), {opacity: 0, x: -40, y: -40}, {opacity: 1, x: 0, y: 0, transformOrigin: '50% 50%', duration: .5}, "-=.35")
			// .to(q6(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%', duration: .5}, "-=.35")    	
			// .to(q6(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: .5, transformOrigin: '50% 50%'}, "-=.35")

			tl.delay(1).play(0);
			tl.eventCallback('onComplete', closeSummerItem, [null]);
			
    	}
    }

    function handleClickAccordion(int) {
    	if(int === accordInt['currentOpen']) {
    		// console.log('1a', accordInt);
    		setAccordInt({currentOpen: null, prevOpen: accordInt['currentOpen'], open: false});
    	} else if(accordInt['currentOpen'] === null) {
    		// console.log('2a', accordInt);
    		setAccordInt({currentOpen: int, prevOpen: int, open: true});
    	} else {
    		// console.log('3a', accordInt);
    		setAccordInt({currentOpen: int, prevOpen: accordInt['currentOpen'], open: true});
    	}
    }

    useEffect(() => {
    	if(accordInt['open'] === false) {
    		// console.log('1', accordInt);
    		closeAccordion(accordInt['prevOpen']);
    	} else if(accordInt['open'] === true && accordInt['currentOpen'] === accordInt['prevOpen']) {	
    		// console.log('2', accordInt);
    		openAccordion(accordInt['currentOpen']);
    	} else {
    		// console.log('3', accordInt);
    		closeAccordion(accordInt['prevOpen']);
    		openAccordion(accordInt['currentOpen']);	
    	}

    	// setAccordInt((prevState) => ({...prevState, prevOpen: int}));
    	function closeAccordion(int) {
    		let accordionParent = gsap.utils.selector(accordionItem.current[int]);
    		let tl = gsap.timeline()
    		.to(accordionParent('.accordion__content'), {height: 0, display: 'none', y: -30, opacity: 0})
    		.to(accordionParent(".rings"), {display: 'none', opacity: 0, rotate: 0,}, "-=.5")
    		.to(accordionParent(".icon"), {scale: .6, transformOrigin: '50% 0%'}, "-=.5")
    		.to(accordionParent(".summer-circle-item .summer-circle"), {scale: .9, transformOrigin: '50% 50%'}, "-=.4")
    		.to(accordionParent(".icon-text"), {scale: 1, opacity: 1, transformOrigin: 'center center', duration: .5}, "-=.6")	
    	}

    	function openAccordion(int) {
    		let accordionParent = gsap.utils.selector(accordionItem.current[int]);
    		let tl = gsap.timeline()
    		.fromTo(accordionParent('.accordion__content'), {display: 'block', height: 0, y: -30, opacity: 0}, {height: 'auto', y: 0, opacity: 1})
    		.to(accordionParent(".icon-text"), {scale: .5, opacity: 0, transformOrigin: 'center center', duration: .5}, "-=.5")
			.to(accordionParent(".icon"), {scale: 1, transformOrigin: '50% 0%', duration: .5}, "-=.4")
			.to(accordionParent(".summer-circle-item .summer-circle"), {scale: 1, transformOrigin: '50% 50%'}, "-=.5")    	
			.to(accordionParent(".rings"), {display: 'block', opacity: 1, rotate: 360, ease: 'power4', duration: 1, transformOrigin: '50% 50%'}, "-=.5")
    	}
    }, [accordInt]);

    useEffect(() => {
    	for(let x = 0; x < accordionItem.current.length; x++) {
    		let accordionParent = gsap.utils.selector(accordionItem.current[x]);
    		gsap.to(accordionParent(".accordion__content"), {display: 'none'});
    	}
    }, []);
	
	return (
		<div className="row row-wrapper p-t-40 p-b-40 m-t-40">
            <div className="col-xs-12">
            	<div style={desktopViewState ? {display: 'block'} : {display: 'none'}}>
                    <VisibilitySensor onChange={onChange} partialVisibility={true} >
                    	<svg 
                    		ref={winterSVG}
                    		className="winter-svg"
                    		version="1.1" 
                    		id="Layer_1" 
                    		xmlns="http://www.w3.org/2000/svg" 
                    		xmlnsXlink="http://www.w3.org/1999/xlink" 
                    		x="0px" 
                    		y="0px"
                    		viewBox="0 0 1376.6 958.4" 
                    		style={{enableBackground:"new 0 0 1376.6 958.4"}} 
                    		xmlSpace="preserve">
	                    	<g id="Layer_1_00000168077328351468380810000000076749825772400308_">
	                    	</g>
	                    	<g>
	                    		<g>
	                    			<path className="st0" d="M688.5,357.4c-47.7,0-94-9.3-137.6-27.8c-42.1-17.8-79.9-43.3-112.4-75.8s-58-70.3-75.8-112.4
	                    				C344.3,97.9,335,51.6,335,3.9h15c0,90.4,35.2,175.4,99.2,239.4s149,99.2,239.4,99.2S864,307.3,928,243.3
	                    				c63.9-63.9,99.2-149,99.2-239.4h15c0,47.7-9.3,94-27.8,137.6c-17.8,42.1-43.3,79.9-75.8,112.4s-70.3,58-112.4,75.8
	                    				C782.6,348,736.3,357.4,688.5,357.4z"/>
	                    			<g>
	                    				<line className="st1" x1="1244.8" y1="7.4" x2="136.8" y2="7.4"/>
	                    				<rect x="136.8" y="-0.1" className="st0" width="1108" height="15"/>
	                    			</g>
	                    			<rect x="388" y="54.7" className="st1" width="588.4" height="153.5"/>
	                    			<text transform="matrix(1 0 0 1 583.2228 89.3634)" className="st2 st3 st4">WINTER </text>
	                    			<text transform="matrix(1 0 0 1 487.3228 141.3634)" className="st2 st3 st4">PERFORMANCE  </text>
	                    			<text transform="matrix(1 0 0 1 457.1228 193.3634)" className="st2 st3 st4">BY THE NUMBERS</text>
	                    			<rect x="546.5" y="222.2" className="st1" width="271.3" height="49.8"/>
	                    			<text transform="matrix(1 0 0 1 602.381 239.3804)" className="st5 st6 st7">Click to Explore</text>
	                    			<polygon className="st2" points="888.5,285.8 892.6,282.9 993.1,451.8 989,454.7 		"/>
	                    			
	                    				<rect x="1077.3" y="96" transform="matrix(0.4396 -0.8982 0.8982 0.4396 444.0894 1070.2878)" className="st2" width="5" height="166.6"/>
	                    			
	                    				<rect x="360.6" y="351.7" transform="matrix(0.5292 -0.8485 0.8485 0.5292 -92.0689 542.543)" className="st2" width="164.6" height="5"/>
	                    			
	                    				<rect x="217.7" y="177.1" transform="matrix(0.894 -0.4481 0.4481 0.894 -48.7888 152.9608)" className="st2" width="162.3" height="5"/>
	                    			<rect x="679.7" y="350.4" className="st2" width="5" height="174"/>
	                    			<circle className="st8" cx="682.2" cy="350.4" r="20.7"/>
	                    			<circle className="st8" cx="890.6" cy="284.3" r="20.7"/>
	                    			<circle className="st8" cx="1005.2" cy="143.2" r="20.7"/>
	                    			<circle className="st8" cx="486.9" cy="284.3" r="20.7"/>
	                    			<circle className="st8" cx="371.4" cy="143.2" r="20.7"/>
	                    		</g>

	                    		<g className="z10" onClick={() => {handleClickSummer(0)}} ref={(element) => {winterItems.current[0] = element}}>
	                    			<g className="text">
	                    				<g>
	                    					<path className="st0" d="M1021.8,737.6H700.6L682.3,706l-18.2,31.6H342.8c-13,0-23.5,10.5-23.5,23.5v171.1c0,13,10.5,23.5,23.5,23.5
	                    						h679c13,0,23.5-10.5,23.5-23.5V761.1C1045.3,748.1,1034.8,737.6,1021.8,737.6z"/>
	                    					<path className="st9" d="M1021.8,956.7h-679c-13.5,0-24.5-11-24.5-24.5V761.1c0-13.5,11-24.5,24.5-24.5h320.7l18.8-32.6l18.8,32.6
	                    						h320.7c13.5,0,24.5,11,24.5,24.5v171.1C1046.3,945.7,1035.4,956.7,1021.8,956.7z M342.8,738.6c-12.4,0-22.5,10.1-22.5,22.5
	                    						v171.1c0,12.4,10.1,22.5,22.5,22.5h679c12.4,0,22.5-10.1,22.5-22.5V761.1c0-12.4-10.1-22.5-22.5-22.5H700L682.3,708l-17.7,30.6
	                    						H342.8z"/>
	                    				</g>
	                    				<rect x="326.4" y="775" className="st1" width="711.8" height="183.3"/>
	                    				<text transform="matrix(1 0 0 1 348.2222 793.0468)" className="st9 st3 st10">To support neighboring systems during the “February </text>
	                    				<text transform="matrix(1 0 0 1 394.7222 825.4468)" className="st9 st3 st10">Freeze” event of 2021, PJM exported a high of</text>
	                    				<text transform="matrix(1 0 0 1 970.0222 825.4468)" className="st8 st3 st10">  </text>
	                    				<text transform="matrix(1 0 0 1 365.1222 857.8468)" className="st8 st3 st10">15,700 MW,</text>
	                    				<text transform="matrix(1 0 0 1 505.8222 857.8468)" className="st9 st3 st10">&nbsp;more than double that of a typical day.  </text>
	                    				<text transform="matrix(1 0 0 1 385.9222 890.2468)" className="st9 st3 st10">As the 2021/2022 winter approached, PJM had  </text>
	                    				<text transform="matrix(1 0 0 1 393.0222 922.6469)" className="st9 st3 st10">more than </text>
	                    				<text transform="matrix(1 0 0 1 527.5222 922.6469)" className="st8 st3 st10">185,000 MW</text>
	                    				<text transform="matrix(1 0 0 1 686.6222 922.6469)" className="st9 st3 st10"> of available resources.</text>
	                    			</g>
	                    			<g>
	                    				<g className="summer-circle-item">
	                    					
                    						<linearGradient id="circ-1" gradientUnits="userSpaceOnUse" x1="618.8253" y1="493.2925" x2="808.8244" y2="201.2569" gradientTransform="matrix(1 0 0 -1 0 957)">
	                    						<stop  offset="0" style={{stopColor:"#FA0089"}}/>
	                    						<stop  offset="1.000839e-02" style={{stopColor:"#F7038A"}}/>
	                    						<stop  offset="0.2063" style={{stopColor:"#C13DA5"}}/>
	                    						<stop  offset="0.3962" style={{stopColor:"#936DBC"}}/>
	                    						<stop  offset="0.5751" style={{stopColor:"#7092CD"}}/>
	                    						<stop  offset="0.7404" style={{stopColor:"#57ADDA"}}/>
	                    						<stop  offset="0.887" style={{stopColor:"#47BDE1"}}/>
	                    						<stop  offset="1" style={{stopColor:"#42C3E4"}}/>
	                    					</linearGradient>
	                    					<path className="summer-circle" style={{fill: "url(#circ-1)"}} d="M570.6,562.5c0,62.1,50.4,112.5,112.5,112.5s112.5-50.4,112.5-112.5S745.2,450,683.1,450
	                    						S570.6,500.4,570.6,562.5"/>
	                    				</g>
	                    				<g className="rings">
	                    					<g id="Group-5_00000112599986983435708720000011903714664881297336_" transform="translate(-3.000000, -3.000000)">
	                    						<path id="Stroke-1_00000143619082702842040190000015494518547859811507_" className="st12" d="M687.2,427.9
	                    							c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S759.8,427.9,687.2,427.9z M687.2,431.6
	                    							c70.5,0,127.7,57.2,127.7,127.7S757.7,687,687.2,687s-127.7-57.2-127.7-127.7S616.6,431.6,687.2,431.6z"/>
	                    						<path id="Stroke-3_00000047742264931338724530000006138140975350206599_" className="st13" d="M687.2,437.1
	                    							c-72.6,0-131.4,58.8-131.4,131.4S614.6,700,687.2,700s131.4-58.8,131.4-131.4S759.8,437.1,687.2,437.1z M687.2,440.9
	                    							c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S616.6,440.9,687.2,440.9z"/>
	                    					</g>
	                    				</g>
	                    				<g className="center-icon">
		                    				<path className="st9" d="M735.8,567.7L735.8,567.7L735.8,567.7v-48.4c0-7.1-5.8-12.8-12.8-12.8h-11.5v-5.3h-4.1v5.3h-48.8v-5.3h-4.1
		                    					v5.3H643c-7.1,0-12.8,5.8-12.8,12.8v80.2c0,7.1,5.8,12.8,12.8,12.8h48.4C715.8,612.3,735.8,592.3,735.8,567.7L735.8,567.7
		                    					L735.8,567.7z M642.8,608.2c-4.8,0-8.7-3.9-8.7-8.7v-60.8h84.6v-4.1h-84.6v-15.2c0-4.8,3.9-8.7,8.7-8.7h11.5v4.7h4.1v-4.7h48.8
		                    					v4.7h4.1v-4.7H723c4.8,0,8.7,3.9,8.7,8.7v48.4l0,0l0,0c0,6.9-5.6,12.6-12.6,12.6h-13.2h-2.1v15.3c0,6.9-5.6,12.6-12.6,12.6l0,0
		                    					L642.8,608.2L642.8,608.2z M704.3,606c2.3-2.9,3.7-6.5,3.7-10.4v-11.2h11.2l0,0l0,0c3.9,0,7.5-1.4,10.4-3.7
		                    					C725.5,592.6,716.1,601.9,704.3,606z M659.1,548.5h-9.9c-3.1,0-5.6,2.5-5.6,5.6v9.9c0,3.1,2.5,5.6,5.6,5.6h9.9
		                    					c3.1,0,5.6-2.5,5.6-5.6v-9.9C664.6,551,662.1,548.5,659.1,548.5z M660.5,564c0,0.8-0.7,1.4-1.5,1.4h-9.9c-0.8,0-1.5-0.6-1.5-1.4
		                    					v-9.9c0-0.8,0.7-1.5,1.5-1.5h9.9c0.8,0,1.5,0.7,1.5,1.5V564z M678,569.6h9.9c3.1,0,5.6-2.5,5.6-5.6v-9.9c0-3.1-2.5-5.6-5.6-5.6
		                    					H678c-3.1,0-5.6,2.5-5.6,5.6v9.9C672.4,567.1,674.9,569.6,678,569.6z M676.5,554.1c0-0.8,0.7-1.5,1.5-1.5h9.9
		                    					c0.8,0,1.4,0.7,1.4,1.5v9.9c0,0.8-0.7,1.4-1.4,1.4H678c-0.8,0-1.5-0.6-1.5-1.4V554.1z M659.1,577.2h-9.9c-3.1,0-5.6,2.5-5.6,5.6
		                    					v9.9c0,3.1,2.5,5.6,5.6,5.6h9.9c3.1,0,5.6-2.5,5.6-5.6v-9.9C664.6,579.7,662.1,577.2,659.1,577.2z M660.5,592.7
		                    					c0,0.8-0.7,1.4-1.5,1.4h-9.9c-0.8,0-1.5-0.6-1.5-1.4v-9.9c0-0.8,0.7-1.4,1.5-1.4h9.9c0.8,0,1.5,0.6,1.5,1.4V592.7z M693.4,592.7
		                    					v-9.9c0-3.1-2.5-5.6-5.6-5.6H678c-3.1,0-5.6,2.5-5.6,5.6v9.9c0,3.1,2.5,5.6,5.6,5.6h9.9C690.9,598.3,693.4,595.8,693.4,592.7z
		                    					 M689.3,592.7c0,0.8-0.7,1.4-1.4,1.4H678c-0.8,0-1.5-0.6-1.5-1.4v-9.9c0-0.8,0.7-1.4,1.5-1.4h9.9c0.8,0,1.4,0.6,1.4,1.4
		                    					L689.3,592.7L689.3,592.7z M706.8,569.6h9.9c3.1,0,5.6-2.5,5.6-5.6v-9.9c0-3.1-2.5-5.6-5.6-5.6h-9.9c-3.1,0-5.6,2.5-5.6,5.6v9.9
		                    					C701.2,567.1,703.7,569.6,706.8,569.6z M705.3,554.1c0-0.8,0.7-1.5,1.5-1.5h9.9c0.8,0,1.5,0.7,1.5,1.5v9.9c0,0.8-0.7,1.4-1.5,1.4
		                    					h-9.9c-0.8,0-1.5-0.6-1.5-1.4V554.1z"/>
                    					</g>
	                    				<g className="icon-text">
	                    					<rect x="622.4" y="598.8" className="st1" width="120.5" height="54.7"/>
	                    					<text transform="matrix(1 0 0 1 652.3765 617.829)" className="st9 st3 st14">FEB. </text>
	                    					<text transform="matrix(1 0 0 1 631.1765 646.429)" className="st9 st3 st14">FREEZE</text>
	                    				</g>
	                    			</g>
	                    		</g>

	                    		<g className="z10" onClick={() => {handleClickSummer(1)}} ref={(element) => {winterItems.current[1] = element}}>
	                    			<g className="text">
	                    				<g>
	                    					<path className="st0" d="M530.5,641.1H399.3l-18.2-31.6l-18.2,31.6H231.7c-13,0-23.5,10.5-23.5,23.5v101c0,13,10.5,23.5,23.5,23.5
	                    						h298.7c13,0,23.5-10.5,23.5-23.5v-101C554,651.6,543.5,641.1,530.5,641.1z"/>
	                    					<path className="st9" d="M530.5,790.1H231.7c-13.5,0-24.5-11-24.5-24.5v-101c0-13.5,11-24.5,24.5-24.5h130.6l18.8-32.6l18.8,32.6
	                    						h130.6c13.5,0,24.5,11,24.5,24.5v101C555,779.1,544,790.1,530.5,790.1z M231.7,642.1c-12.4,0-22.5,10.1-22.5,22.5v101
	                    						c0,12.4,10.1,22.5,22.5,22.5h298.7c12.4,0,22.5-10.1,22.5-22.5v-101c0-12.4-10.1-22.5-22.5-22.5H398.8l-17.7-30.6l-17.7,30.6
	                    						H231.7z"/>
	                    				</g>
	                    				<rect x="225.6" y="678.5" className="st1" width="311" height="103.7"/>
	                    				<text transform="matrix(1 0 0 1 229.21 696.5203)" className="st9 st3 st10">PJM’s 2020/2021 winter </text>
	                    				<text transform="matrix(1 0 0 1 230.51 728.9203)" className="st9 st3 st10">peak was approximately </text>
	                    				<text transform="matrix(1 0 0 1 301.01 761.3203)" className="st8 st3 st10">117,000 MW.</text>
	                    			</g>
	                    			<g className="summer-circle-item">
	                    				
                    					<linearGradient id="SVGID_00000090996259200908641950000008201030919637399739_" gradientUnits="userSpaceOnUse" x1="308.9286" y1="746.9136" x2="457.8042" y2="563.9445" gradientTransform="matrix(1 0 0 -1 0 1121)">
	                    					<stop  offset="0" style={{stopColor:"#7EBB1F"}}/>
	                    					<stop  offset="2.708180e-04" style={{stopColor:"#7EBB1F"}}/>
	                    					<stop  offset="0.2524" style={{stopColor:"#80BB1C"}}/>
	                    					<stop  offset="0.424" style={{stopColor:"#88BB1B"}}/>
	                    					<stop  offset="0.5717" style={{stopColor:"#97BB19"}}/>
	                    					<stop  offset="0.7059" style={{stopColor:"#AFBC15"}}/>
	                    					<stop  offset="0.8309" style={{stopColor:"#C9BC0E"}}/>
	                    					<stop  offset="0.9476" style={{stopColor:"#ECBD09"}}/>
	                    					<stop  offset="0.9997" style={{stopColor:"#FDBD00"}}/>
	                    					<stop  offset="1" style={{stopColor:"#FDBD00"}}/>
	                    				</linearGradient>
	                    				<circle className="summer-circle" style={{fill:"url(#SVGID_00000090996259200908641950000008201030919637399739_)"}} cx="381.6" cy="463.4" r="112.5"/>
	                    				<rect x="324.4" y="505.1" className="st1" width="113.8" height="51.6"/>
	                    				<g className="icon-text">
		                    				<text transform="matrix(1 0 0 1 332.7549 523.1512)" className="st9 st3 st10">117,000 </text>
		                    				<text transform="matrix(1 0 0 1 356.7549 550.1512)" className="st9 st3 st10">MW</text>
		                    			</g>
	                    				<g className="rings">
	                    					<g id="Group-5_00000041983512039974623920000010713688505345218436_" transform="translate(-3.000000, -3.000000)">
	                    						<path id="Stroke-1_00000088836172138884456960000016804162630556012176_" className="st12" d="M384.1,331.3
	                    							c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S456.7,331.3,384.1,331.3z M384.1,335
	                    							c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S313.6,335,384.1,335z"/>
	                    						<path id="Stroke-3_00000002369286573642407760000014648267785608918710_" className="st13" d="M384.1,340.5
	                    							c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S456.7,340.5,384.1,340.5z M384.1,344.2
	                    							c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S313.6,344.2,384.1,344.2z"/>
	                    					</g>
	                    				</g>
	                    				<g className="center-icon">
		                    				<path className="st9" d="M357.7,430.8l10.6,6.1c0.3,0.2,0.6,0.2,0.9,0.2s0.6-0.1,0.9-0.2c0.6-0.3,0.9-0.9,0.9-1.6v-12.2
		                    					c0-0.6-0.3-1.2-0.9-1.6l-10.6-6.1c-0.1,0-0.2-0.1-0.2-0.1c-0.9-0.4-1.9,0-2.3,0.9c-0.2,0.3-0.2,0.7-0.2,1v12
		                    					C356.8,429.9,357.2,430.5,357.7,430.8z M360.4,420.2l7,4v8.1l-7-4V420.2z M336.7,455.3l10.4,6c0.3,0.2,0.6,0.2,0.9,0.2
		                    					s0.6-0.1,0.9-0.2l10.6-6.1c0.6-0.3,0.9-0.9,0.9-1.6c0-0.6-0.3-1.2-0.9-1.6l-10.6-6.1c-0.6-0.3-1.2-0.3-1.8,0l-10.6,6.1
		                    					c0,0-0.1,0-0.1,0.1c-0.8,0.5-1,1.6-0.5,2.4C336.1,455,336.4,455.2,336.7,455.3z M348,449.7l7,4l-7,4l-7-4L348,449.7z M371,484.2
		                    					V472c0-0.6-0.3-1.2-0.9-1.6c-0.6-0.3-1.2-0.3-1.8,0l-10.6,6.1c-0.6,0.3-0.9,0.9-0.9,1.6v12.2l0,0c0,1,0.8,1.8,1.8,1.8
		                    					c0.4,0,0.8-0.1,1.1-0.3l10.4-6C370.7,485.5,371,484.9,371,484.2z M367.4,483.2l-7,4v-8l7-4V483.2z M401.9,476.6l-10.6-6.1
		                    					c-0.6-0.3-1.2-0.3-1.8,0c-0.6,0.3-0.9,0.9-0.9,1.6v12.2c0,0.6,0.3,1.2,0.9,1.6l10.6,6.1c0.3,0.2,0.6,0.2,0.9,0.2
		                    					c0.6,0,1.2-0.3,1.5-0.8c0.2-0.3,0.3-0.7,0.3-1.1v-12.1C402.8,477.5,402.4,476.9,401.9,476.6z M399.2,487.2l-7-4v-8.1l7,4V487.2z
		                    					 M422.9,452.1l-10.5-6.1c-0.6-0.3-1.2-0.3-1.8,0l-10.6,6.1c-0.6,0.3-0.9,0.9-0.9,1.6c0,0.6,0.3,1.2,0.9,1.6l10.6,6.1
		                    					c0.3,0.2,0.6,0.2,0.9,0.2s0.6-0.1,0.9-0.2l10.6-6.1c0.8-0.5,1.1-1.5,0.7-2.3C423.6,452.6,423.3,452.3,422.9,452.1z M411.5,457.7
		                    					l-7-4l7-4l7,4L411.5,457.7z M388.6,423.1v12.2c0,0.6,0.3,1.2,0.9,1.6c0.3,0.2,0.6,0.2,0.9,0.2s0.6-0.1,0.9-0.2l10.6-6.1
		                    					c0.6-0.3,0.9-0.9,0.9-1.6V417c0-0.9-0.7-1.7-1.6-1.8c-0.4,0-0.8,0.1-1.2,0.3l-10.5,6.1C388.9,421.9,388.6,422.5,388.6,423.1z
		                    					 M399.1,420.2v8l-7,4v-8L399.1,420.2z M428.1,467.1l-10.7,6.2l7.9,4.5l-1.8,3.1l-7.9-4.5v12.4H412v-14.4l-30.4-17.5V492l12.5,7.2
		                    					l-1.8,3.1l-10.7-6.2v9.1H378v-9.1l-10.7,6.2l-1.8-3.1L378,492v-35.1l-30.4,17.6v14.4H344v-12.3l-7.9,4.5l-1.8-3.1l7.9-4.5
		                    					l-10.7-6.2l1.8-3.1l12.5,7.2l30.4-17.5l-30.4-17.6l-12.5,7.2l-1.8-3.1l10.7-6.2l-7.9-4.5l1.8-3.1l7.9,4.5v-12.4h3.6V433
		                    					l30.4,17.6v-35.1l-12.5-7.2l1.8-3.1l10.7,6.2v-9.1h3.6v9.1l10.7-6.2l1.8,3.1l-12.5,7.2v35.1L412,433v-14.4h3.6v12.3l7.9-4.5
		                    					l1.8,3.1l-7.9,4.5l10.7,6.2l-1.8,3.1l-12.5-7.2l-30.4,17.5l30.4,17.6l12.5-7.2L428.1,467.1z"/>
		                    			</g>
	                    			</g>
	                    		</g>

	                    		<g className="z10" onClick={() => {handleClickSummer(2)}} ref={(element) => {winterItems.current[2] = element}}>
	                    			<g className="text">
	                    				<g>
	                    					<path className="st0" d="M1158.4,642.3h-151.1l-18.2-31.6l-18.2,31.6H819.6c-13,0-23.5,10.5-23.5,23.5v141.1
	                    						c0,13,10.5,23.5,23.5,23.5h338.8c13,0,23.5-10.5,23.5-23.5V665.8C1181.9,652.8,1171.4,642.3,1158.4,642.3z"/>
	                    					<path className="st9" d="M1158.4,831.4H819.6c-13.5,0-24.5-11-24.5-24.5V665.8c0-13.5,11-24.5,24.5-24.5h150.6l18.8-32.6l18.8,32.6
	                    						h150.6c13.5,0,24.5,11,24.5,24.5v141.1C1182.9,820.4,1171.9,831.4,1158.4,831.4z M819.6,643.3c-12.4,0-22.5,10.1-22.5,22.5
	                    						v141.1c0,12.4,10.1,22.5,22.5,22.5h338.8c12.4,0,22.5-10.1,22.5-22.5V665.8c0-12.4-10.1-22.5-22.5-22.5h-151.7L989,612.7
	                    						l-17.7,30.6H819.6z"/>
	                    				</g>
	                    				<rect x="819.2" y="679.7" className="st1" width="339.6" height="130.9"/>
	                    				<text transform="matrix(1 0 0 1 828.619 697.7568)" className="st8 st3 st10">169,682 MW </text>
	                    				<text transform="matrix(1 0 0 1 993.719 697.7568)" className="st9 st3 st10">of estimated </text>
	                    				<text transform="matrix(1 0 0 1 862.519 730.1568)" className="st9 st3 st10">available generation </text>
	                    				<text transform="matrix(1 0 0 1 843.619 762.5568)" className="st9 st3 st10">represented committed </text>
	                    				<text transform="matrix(1 0 0 1 869.519 794.9568)" className="st9 st3 st10">capacity resources.</text>
	                    			</g>
	                    			<g>
	                    				<g className="summer-circle-item">
	                    					
                    						<linearGradient id="SVGID_00000024722287158749960060000005570247272715469718_" gradientUnits="userSpaceOnUse" x1="948.6968" y1="542.6434" x2="1142.811" y2="304.0755" gradientTransform="matrix(1 0 0 -1 0 957)">
	                    						<stop  offset="0" style={{stopColor:"#FFC000"}}/>
	                    						<stop  offset="0.1129" style={{stopColor:"#FEB906"}}/>
	                    						<stop  offset="0.2803" style={{stopColor:"#FAA515"}}/>
	                    						<stop  offset="0.4816" style={{stopColor:"#F5842E"}}/>
	                    						<stop  offset="0.7093" style={{stopColor:"#ED5651"}}/>
	                    						<stop  offset="0.9561" style={{stopColor:"#E41C7D"}}/>
	                    						<stop  offset="1" style={{stopColor:"#E21185"}}/>
	                    					</linearGradient>
	                    					<circle className="summer-circle" style={{fill:"url(#SVGID_00000024722287158749960060000005570247272715469718_)"}} cx="991.4" cy="466.8" r="112.5"/>
	                    				</g>
	                    				<rect x="936.6" y="507.5" className="st1" width="113.8" height="51.6"/>
	                    				<g className="icon-text">
		                    				<text transform="matrix(1 0 0 1 942.2877 525.5334)" className="st9 st3 st10">169,682 </text>
		                    				<text transform="matrix(1 0 0 1 968.9877 552.5334)" className="st9 st3 st10">MW</text>
	                    				</g>
	                    				<g className="rings">
	                    					<g id="Group-5_00000080204601186260207440000009502836707134645926_" transform="translate(-3.000000, -3.000000)">
	                    						<path id="Stroke-1_00000099649036214780535730000007660589373858321544_" className="st12" d="M993.9,332.6
	                    							c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S1066.4,332.6,993.9,332.6z M993.9,336.3
	                    							c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7S866.2,534.5,866.2,464S923.3,336.3,993.9,336.3z"/>
	                    						<path id="Stroke-3_00000161632895394551735230000004598081598511190199_" className="st13" d="M993.9,341.8
	                    							c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S1066.4,341.8,993.9,341.8z M993.9,345.6
	                    							c70.5,0,127.7,57.2,127.7,127.7S1064.4,601,993.9,601s-127.7-57.2-127.7-127.7S923.3,345.6,993.9,345.6z"/>
	                    					</g>
	                    				</g>
	                    				<g className="center-icon">
		                    				<path className="st9" d="M948.9,435h15.9h0.1c3.1-0.5,5.5-3.4,5.5-6.8c0-3.8-3.1-7-6.9-7c-1.1-2.6-3.6-4.3-6.5-4.3
		                    					c-2.8,0-5.4,1.8-6.4,4.3h-0.1c-3.9,0-7,3.1-7,7C943.4,431.6,945.8,434.6,948.9,435z M950.4,424.7c0.3,0,0.6,0,0.9,0.2l2,0.6
		                    					l0.3-2.1c0.2-1.7,1.7-3,3.4-3s3.1,1.2,3.4,2.9l0.3,1.9l1.9-0.5c0.3-0.1,0.6-0.1,0.8-0.1c1.9,0,3.4,1.5,3.4,3.4c0,1.6-1,3-2.3,3.2
		                    					h-15.3c-1.2-0.2-2.2-1.7-2.2-3.2C947,426.3,948.6,424.7,950.4,424.7z M1017.7,436c2.9,0,5.4,1.7,6.5,4.3c3.8,0,6.9,3.2,6.9,7
		                    					h-3.6c0-1.9-1.5-3.4-3.4-3.4c-0.2,0-0.5,0-0.8,0.1l-1.9,0.5l-0.3-1.9c-0.3-1.7-1.7-2.9-3.4-2.9c-1.7,0-3.1,1.3-3.4,3l-0.3,2.1
		                    					l-2-0.6c-0.4-0.1-0.7-0.2-0.9-0.2c-1.9,0-3.4,1.5-3.4,3.4c0,1.6,1,3,2.2,3.2h15.4v3.6h-15.8c-3.1-0.4-5.4-3.3-5.4-6.8
		                    					c0-3.9,3.3-7.1,7.1-7C1012.3,437.8,1014.8,436,1017.7,436z M1025.7,505.7V471l13.2,18l2.9-2.1l-15.7-21.3l14.4-22.3l-3-2
		                    					l-14.6,22.5l-11.3,0.2l0.1,3.6l10.4-0.2v38.4h-28.6l-1.2-39.9l11.8,16l9.7-0.3l-14-27.1l-8.3-5.1l21.6-33.4l-3.7-9L989,429.7
		                    					l-1.8,9.6c-0.4-0.1-0.9-0.1-1.3-0.1h-0.1l0,0l-39.9,0.3l-5.5,8l30.2,4.6l9.1-3.8c0.1,0.3,0.3,0.6,0.4,0.9l-2,56.6h-16.3v-23.4
		                    					l8.8,11.9l2.9-2.1l-11.3-15.3l10.4-16l-3-2L959,475l-19.4,0.2v3.6l18.5-0.2v27.1h-18v3.6H1042v-3.6H1025.7z M1023.9,465.5
		                    					L1023.9,465.5L1023.9,465.5L1023.9,465.5z M959.9,476.8L959.9,476.8L959.9,476.8L959.9,476.8z M1007.9,478.1l-2.1,0.1l-19-25.8
		                    					c0.6-0.1,1.3-0.3,1.8-0.6l8.4,5.2L1007.9,478.1z M992.3,431.2l15.9-17.7l0.8,2l-17.4,27c-0.3-0.6-0.7-1.1-1.2-1.5L992.3,431.2z
		                    					 M988.8,445.7c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1C987.5,442.7,988.8,444,988.8,445.7z M970.1,448.3
		                    					l-23.6-3.6l1.2-1.8l32.1-0.3c-0.3,0.6-0.5,1.2-0.6,1.8L970.1,448.3z M983.5,453.8l5,6.8l1.4,45h-8.2L983.5,453.8z"/>
		                    			</g>
	                    			</g>
	                    		</g>

	                    		<g className="z10" onClick={() => {handleClickSummer(3)}} ref={(element) => {winterItems.current[3] = element}}>
	                    			<g className="text">
	                    				<g>
	                    					<path className="st0" d="M323.4,416.7H192.2L174,385.2l-18.2,31.6H24.6c-13,0-23.5,10.5-23.5,23.5v141.1c0,13,10.5,23.5,23.5,23.5
	                    						h298.7c13,0,23.5-10.5,23.5-23.5V440.2C346.9,427.3,336.3,416.7,323.4,416.7z"/>
	                    					<path className="st9" d="M323.4,605.8H24.6c-13.5,0-24.5-11-24.5-24.5V440.2c0-13.5,11-24.5,24.5-24.5h130.6l18.8-32.6l18.8,32.6
	                    						h130.6c13.5,0,24.5,11,24.5,24.5v141.1C347.9,594.8,336.9,605.8,323.4,605.8z M24.6,417.7c-12.4,0-22.5,10.1-22.5,22.5v141.1
	                    						c0,12.4,10.1,22.5,22.5,22.5h298.7c12.4,0,22.5-10.1,22.5-22.5V440.2c0-12.4-10.1-22.5-22.5-22.5H191.7L174,387.2l-17.7,30.6
	                    						H24.6V417.7z"/>
	                    				</g>
	                    				<rect x="18.8" y="454.2" className="st1" width="310.4" height="131.1"/>
	                    				<text transform="matrix(1 0 0 1 43.9065 472.1903)" className="st9 st3 st10">PJM’s all-time winter </text>
	                    				<text transform="matrix(1 0 0 1 88.4065 504.5903)" className="st9 st3 st10">peak of about  </text>
	                    				<text transform="matrix(1 0 0 1 25.6065 536.9903)" className="st8 st3 st10">143,295 MW </text>
	                    				<text transform="matrix(1 0 0 1 190.3065 536.9903)" className="st9 st3 st10">was set on </text>
	                    				<text transform="matrix(1 0 0 1 90.4065 569.3903)" className="st9 st3 st10">Feb. 20, 2015.</text>
	                    			</g>
	                    			<g>
	                    				<g className="summer-circle-item">
	                    					
	                    						<linearGradient id="SVGID_00000176045315662365214340000003156803671356868532_" gradientUnits="userSpaceOnUse" x1="100.8184" y1="969.4263" x2="296.2351" y2="729.2576" gradientTransform="matrix(1 0 0 -1 0 1121)">
	                    						<stop  offset="0" style={{stopColor:"#42C3E4"}}/>
	                    						<stop  offset="0.1714" style={{stopColor:"#42C3E4"}}/>
	                    						<stop  offset="0.2633" style={{stopColor:"#44C3DE"}}/>
	                    						<stop  offset="0.3836" style={{stopColor:"#49C2CE"}}/>
	                    						<stop  offset="0.5195" style={{stopColor:"#51C2B3"}}/>
	                    						<stop  offset="0.6669" style={{stopColor:"#5DC08D"}}/>
	                    						<stop  offset="0.8236" style={{stopColor:"#6BBF5D"}}/>
	                    						<stop  offset="0.9859" style={{stopColor:"#7DBD22"}}/>
	                    						<stop  offset="1" style={{stopColor:"#7FBD1D"}}/>
	                    					</linearGradient>
	                    					<circle className="summer-circle" style={{fill:"url(#SVGID_00000176045315662365214340000003156803671356868532_)"}} cx="173.5" cy="240.9" r="112.5"/>
	                    					<g className="rings">
	                    						<g id="Group-5_00000125599426058015876420000013211165119788903321_" transform="translate(-3.000000, -3.000000)">
	                    							<path id="Stroke-1_00000135673208832868010400000000495460906811910061_" className="st12" d="M176.2,107.1
	                    								c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S248.8,107.1,176.2,107.1z M176.2,110.8
	                    								c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7S48.5,309,48.5,238.5S105.7,110.8,176.2,110.8z"/>
	                    							<path id="Stroke-3_00000000903254258023958330000017921586334828062393_" className="st13" d="M176.2,116.3
	                    								c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S248.8,116.3,176.2,116.3z M176.2,120
	                    								c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7S48.5,318.2,48.5,247.7S105.7,120,176.2,120z"/>
	                    						</g>
	                    					</g>
	                    					<g className="center-icon">
		                    					<path className="st9" d="M220.7,222.4c2,0,3.8-0.8,5.2-2.2s2.2-3.2,2.2-5.2s-0.8-3.8-2.2-5.2c-1.2-1.2-2.7-1.9-4.4-2.1
		                    						c-0.1-3.4-1.4-6.6-3.8-9c-2.5-2.5-5.8-3.8-9.3-3.8l0,0c-6.5,0-11.8,4.6-12.9,10.7c-0.2,0-0.4,0-0.5,0l0,0c-2.6,0-5,1.2-6.5,3.2
		                    						l-5.2-7.7l-23.1,37.8l-10.4-15.4l-5.1,7.5c-0.6-2-1.7-3.9-3.2-5.4c-2.5-2.5-5.8-3.8-9.3-3.8l0,0c-6.5,0-11.8,4.6-12.9,10.7
		                    						c-3.5-0.3-6.7,1.7-8.2,4.9c-0.5,1.1-0.8,2.3-0.8,3.5c0,2.2,0.9,4.4,2.5,6s3.7,2.5,6,2.5h13.5l-21.6,32l2.8,1.9l23.8-35.2
		                    						l7.2,7.2l5.2-6.4l5.2,6.5l7.2-7.2l24,35.5l2.8-1.9l-26.8-39.5l8.9-14.6l6.9,6.9l5.2-6.4l5.2,6.5l7.8-7.8l23.8,35.1l2.8-1.9
		                    						l-25.2-37.2L220.7,222.4L220.7,222.4z M118.6,245.7c-1.3,0-2.6-0.5-3.5-1.5c-0.9-0.9-1.5-2.2-1.5-3.5c0-0.7,0.2-1.4,0.5-2.1
		                    						c0.8-1.8,2.6-2.9,4.5-2.9c0.5,0,0.9,0.1,1.5,0.3l2.2,0.7l0.1-2.3c0.1-5.3,4.4-9.4,9.7-9.4l0,0c2.6,0,5,1,6.8,2.8
		                    						s2.8,4.3,2.8,6.8c0,0.1,0,0.2,0,0.4l-7.2,10.7H118.6z M155.2,250l-5.5-6.8l-5.5,6.8l-4.8-4.8l-1,1l6.6-9.7h0.1
		                    						c0-0.1,0-0.1,0-0.2l4.6-6.8l10.5,15.5L155.2,250z M194.2,223.7l-5.4,5.4l-5.5-6.8l-5.5,6.8l-4.8-4.8l0,0l10.4-17l11.5,17
		                    						L194.2,223.7z M190.5,211.8c0.8-1.7,2.6-2.8,4.5-2.8l0,0c0.5,0,1,0.1,1.5,0.3l2.2,0.7l0.1-2.3c0.1-5.3,4.4-9.4,9.7-9.4l0,0
		                    						c2.6,0,5,1,6.8,2.8s2.8,4.3,2.8,6.8c0,0.4,0,0.9-0.1,1.3l-0.3,2.3l2.3-0.4c0.2,0,0.4-0.1,0.7-0.1c2.2,0,4,1.8,4,4
		                    						c0,1.1-0.4,2.1-1.2,2.8c-0.7,0.7-1.7,1.2-2.8,1.2l0,0h-25.3L190.5,211.8z"/>
		                    				</g>
	                    				</g>
	                    				<rect x="117.4" y="279.6" className="st1" width="113.8" height="51.6"/>
	                    				<g className="icon-text">
		                    				<text transform="matrix(1 0 0 1 123.3297 297.6486)" className="st9 st3 st10">143,295 </text>
		                    				<text transform="matrix(1 0 0 1 149.8297 324.6486)" className="st9 st3 st10">MW</text>
	                    				</g>
	                    			</g>
	                    		</g>

	                    		<g className="z10" onClick={() => {handleClickSummer(4)}} ref={(element) => {winterItems.current[4] = element}}>
	                    			<g className="text">
	                    				<g>
	                    					<path className="st0" d="M1352.2,422.3h-131.1l-18.2-31.6l-18.2,31.6h-131.1c-13,0-23.5,10.5-23.5,23.5v141.1
	                    						c0,13,10.5,23.5,23.5,23.5h298.7c13,0,23.5-10.5,23.5-23.5V445.8C1375.7,432.8,1365.2,422.3,1352.2,422.3z"/>
	                    					<path className="st9" d="M1352.2,611.3h-298.7c-13.5,0-24.5-11-24.5-24.5v-141c0-13.5,11-24.5,24.5-24.5h130.6l18.8-32.6l18.8,32.6
	                    						h130.6c13.5,0,24.5,11,24.5,24.5v141.1C1376.7,600.3,1365.7,611.3,1352.2,611.3z M1053.5,423.3c-12.4,0-22.5,10.1-22.5,22.5
	                    						v141.1c0,12.4,10.1,22.5,22.5,22.5h298.7c12.4,0,22.5-10.1,22.5-22.5V445.8c0-12.4-10.1-22.5-22.5-22.5h-131.7l-17.7-30.6
	                    						l-17.7,30.6H1053.5z"/>
	                    				</g>
	                    				<rect x="1056.5" y="459.7" className="st1" width="292.8" height="139.8"/>
	                    				<text transform="matrix(1 0 0 1 1083.116 477.7304)" className="st9 st3 st10">For the 2021/2022 </text>
	                    				<text transform="matrix(1 0 0 1 1059.7159 510.1304)" className="st9 st3 st10">winter, PJM forecasted </text>
	                    				<text transform="matrix(1 0 0 1 1064.7159 542.5304)" className="st9 st3 st10">a peak winter demand </text>
	                    				<text transform="matrix(1 0 0 1 1064.616 574.9304)" className="st9 st3 st10">of about </text>
	                    				<text transform="matrix(1 0 0 1 1175.516 574.9304)" className="st8 st3 st10">133,000 MW.</text>
	                    			</g>
	                    			<g className="summer-circle-item">
	                    				
	                    					<linearGradient id="SVGID_00000177465836075837601460000000036784916649383088_" gradientUnits="userSpaceOnUse" x1="1129.6011" y1="964.8477" x2="1311.9069" y2="740.7925" gradientTransform="matrix(1 0 0 -1 0 1121)">
	                    					<stop  offset="0" style={{stopColor:"#42C3E4"}}/>
	                    					<stop  offset="0.1714" style={{stopColor:"#42C3E4"}}/>
	                    					<stop  offset="0.2633" style={{stopColor:"#44C3DE"}}/>
	                    					<stop  offset="0.3836" style={{stopColor:"#49C2CE"}}/>
	                    					<stop  offset="0.5195" style={{stopColor:"#51C2B3"}}/>
	                    					<stop  offset="0.6669" style={{stopColor:"#5DC08D"}}/>
	                    					<stop  offset="0.8236" style={{stopColor:"#6BBF5D"}}/>
	                    					<stop  offset="0.9859" style={{stopColor:"#7DBD22"}}/>
	                    					<stop  offset="1" style={{stopColor:"#7FBD1D"}}/>
	                    				</linearGradient>
	                    				<circle className="summer-circle" style={{fill:"url(#SVGID_00000177465836075837601460000000036784916649383088_)"}} cx="1202.3" cy="245.5" r="112.5"/>
	                    				<rect x="1146.9" y="289.5" className="st1" width="113.8" height="51.6"/>
	                    				<g className="icon-text">
		                    				<text transform="matrix(1 0 0 1 1152.6387 307.4924)" className="st9 st3 st10">133,000</text>
		                    				<text transform="matrix(1 0 0 1 1179.3386 334.4924)" className="st9 st3 st10">MW</text>
		                    			</g>
	                    				<g className="rings">
	                    					<g id="Group-5_00000087374569629400733930000010572409221459577518_" transform="translate(-3.000000, -3.000000)">
	                    						<path id="Stroke-1_00000013894840305249978990000010051699895953673902_" className="st12" d="M1205.1,112.6
	                    							c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S1277.7,112.6,1205.1,112.6z M1205.1,116.3
	                    							c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S1134.6,116.3,1205.1,116.3z"/>
	                    						<path id="Stroke-3_00000181063069507162987970000012214715919005315495_" className="st13" d="M1205.1,121.8
	                    							c-72.6,0-131.4,58.8-131.4,131.4s58.8,131.4,131.4,131.4s131.4-58.8,131.4-131.4S1277.7,121.8,1205.1,121.8z M1205.1,125.5
	                    							c70.5,0,127.7,57.2,127.7,127.7s-57.2,127.7-127.7,127.7s-127.7-57.2-127.7-127.7S1134.6,125.5,1205.1,125.5z"/>
	                    					</g>
	                    				</g>
	                    				<g className="center-icon">
		                    				<path className="st9" d="M1159.6,265.3l-3.1,1.8c-1.1-2-2.1-4.1-3-6.3c-2.6-6.4-3.9-13.2-3.9-20.2s1.3-13.8,3.9-20.2
		                    					c2.5-6.2,6-11.7,10.5-16.5c4.1-4.3,8.8-7.8,14.1-10.4l-3-7.5l2.4-1l30,4.5l-18.4,25.2l-2.4,1l-2.7-7.3c-3.3,1.7-6.3,4-9,6.8
		                    					c-3.1,3.3-5.5,7.1-7.2,11.3c-1.8,4.4-2.7,9.1-2.7,13.9s0.9,9.5,2.7,13.9c1.1,2.6,2.4,5.1,4,7.4l-2.9,2.1
		                    					c-1.8-2.5-3.2-5.2-4.4-8.1c-1.9-4.8-2.9-10-2.9-15.2s1-10.4,2.9-15.2c1.9-4.7,4.5-8.9,8-12.5c3.4-3.6,7.4-6.5,11.8-8.4l1.8-0.8
		                    					l2.2,6.1l12.7-17.5l-20.9-3.2l2.5,6.3l-1.6,0.7c-5.4,2.4-10.3,5.9-14.5,10.3c-4.2,4.4-7.5,9.6-9.8,15.4c-2.4,6-3.6,12.3-3.6,18.8
		                    					s1.2,12.9,3.6,18.8C1157.6,261.5,1158.5,263.4,1159.6,265.3z M1233.4,279.4c-5,4.2-10.6,7.5-16.6,9.5c-5.9,2-11.9,2.9-18,2.6
		                    					s-11.9-1.7-17.3-4.3l-1.6-0.7l-3.1,6l-11.2-17.9l21.6-1.7l-3.2,5.7l1.7,0.8c4.4,2.1,9.1,3.3,14.1,3.5s9.9-0.5,14.7-2.1
		                    					c4.9-1.7,9.5-4.3,13.5-7.7c4-3.4,7.3-7.5,9.7-12.1l-3.2-1.7c-2.2,4.2-5.2,7.9-8.8,11.1c-3.7,3.1-7.8,5.5-12.3,7
		                    					c-4.3,1.5-8.8,2.1-13.3,1.9c-3.8-0.2-7.5-1-11-2.4l3.8-6.7l-2.3-1.1l-31.1,2.5l16,25.7l2.4,1.2l3.7-7.1
		                    					c5.4,2.3,11.1,3.6,17.1,3.9c6.6,0.3,13.1-0.6,19.4-2.7c6.5-2.2,12.5-5.6,17.8-10.2c3.8-3.3,7.2-7.1,10-11.2l-3-2
		                    					C1240.1,272.8,1237,276.3,1233.4,279.4z M1263.6,238.1l-8-0.1c-0.3-5.8-1.7-11.5-4.1-17c-2.6-6-6.4-11.4-11.1-16.1
		                    					c-4.9-4.8-10.6-8.7-17.1-11.4c-3.1-1.3-6.3-2.3-9.6-3.1l-0.8,3.5c3,0.7,6.1,1.6,9,2.9c6,2.5,11.4,6.1,15.9,10.6
		                    					c4.4,4.4,7.9,9.4,10.3,15c2.5,5.6,3.8,11.4,3.9,17.4v1.7l6.8,0.1l-11,18l-11.2-18.6l6.5,0.3v-1.9c-0.1-4.9-1.2-9.6-3.2-14.2
		                    					c-2-4.5-4.8-8.6-8.4-12.2c-3.7-3.7-8-6.6-12.9-8.6c-3.8-1.6-7.7-2.6-11.7-3l-0.4,3.6c3.7,0.4,7.3,1.3,10.7,2.8
		                    					c4.4,1.9,8.4,4.5,11.8,7.9c3.3,3.2,5.8,7,7.6,11.1c1.5,3.5,2.5,7.2,2.8,10.9l-7.7-0.4v2.6l16.1,26.7l15.8-25.8L1263.6,238.1z
		                    					 M1212.5,216.7l-8.4,19h15.7l-22,30.3h-6.3l7.7-19h-15.8l22.7-30.3H1212.5z M1205.7,223.2l-15.1,20.2h14l-6.6,16.2l14.7-20.3
		                    					h-14.2L1205.7,223.2z"/>
		                    			</g>
	                    			</g>
	                    		</g>
	                    	</g>
                    	</svg>

	                </VisibilitySensor>    
                </div>
                <div style={desktopViewState ? {display: 'none'} : {display: 'block'}} className="mobile-accordion">
                	<div>
						<img className="mobile-header" src={winterMobileHeader} alt="" /> 
            		</div>
                	<div ref={(element) => {accordionItem.current[0] = element}} className="accordion__item">
                		<div onClick={() => {handleClickAccordion(0)}} className="accordion__trigger">
                			<svg 
                				ref={(element) => {triggers.current[0] = element}}
                				version="1.1" 
                				id="winter-trigger-1" 
                				xmlns="http://www.w3.org/2000/svg" 
                				xmlnsXlink="http://www.w3.org/1999/xlink" 
                				x="0px" 
                				y="0px"
                				viewBox="0 0 206.7 213.9" 
                				style={{enableBackground:"new 0 0 206.7 213.9"}} 
                				xmlSpace="preserve">
								<g id="Layer_1_00000138560986797617883830000004169698376206249359_">
								</g>
								<g className="summer-circle-item">
									<linearGradient id="winter-trigger1" gradientUnits="userSpaceOnUse" x1="56.7662" y1="50.2382" x2="175.8667" y2="196.6135">
										<stop  offset="0" style={{stopColor:"#42C3E4"}}/>
										<stop  offset="0.1714" style={{stopColor:"#42C3E4"}}/>
										<stop  offset="0.2633" style={{stopColor:"#44C3DE"}}/>
										<stop  offset="0.3836" style={{stopColor:"#49C2CE"}}/>
										<stop  offset="0.5195" style={{stopColor:"#51C2B3"}}/>
										<stop  offset="0.6669" style={{stopColor:"#5DC08D"}}/>
										<stop  offset="0.8236" style={{stopColor:"#6BBF5D"}}/>
										<stop  offset="0.9859" style={{stopColor:"#7DBD22"}}/>
										<stop  offset="1" style={{stopColor:"#7FBD1D"}}/>
									</linearGradient>
									<circle style={{fill: "url(#winter-trigger1)"}} className="st0 summer-circle" cx="102.6" cy="106.5" r="90"/>
									<rect x="59.3" y="134.1" className="st1" width="88" height="39.9"/>
									<g className="icon-text">
										<text transform="matrix(1 0 0 1 63.8769 148.0507)"><tspan x="0" y="0" className="st2 st3 st4">143,295</tspan><tspan x="20.5" y="20.9" className="st2 st3 st4">MW</tspan></text>
									</g>
									<g className="rings">
										<g id="Group-5_00000008862299197712017850000009111307846183407760_" transform="translate(-3.000000, -3.000000)">
											<path id="Stroke-1_00000074418743446032305290000006934061210403169695_" className="st5" d="M106,3.5C48.9,3.5,2.7,49.8,2.7,106.9
												S48.9,210.2,106,210.2c57.1,0,103.3-46.3,103.3-103.3S163.1,3.5,106,3.5z M106,6.5c55.5,0,100.4,45,100.4,100.4
												s-45,100.4-100.4,100.4c-55.5,0-100.4-45-100.4-100.4S50.5,6.5,106,6.5z"/>
											<path id="Stroke-3_00000148655789225019747110000007256094323204977081_" className="st6" d="M106,10.8C48.9,10.8,2.7,57.1,2.7,114.1
												S48.9,217.5,106,217.5c57.1,0,103.3-46.3,103.3-103.3S163.1,10.8,106,10.8z M106,13.7c55.5,0,100.4,45,100.4,100.4
												s-45,100.4-100.4,100.4c-55.5,0-100.4-45-100.4-100.4S50.5,13.7,106,13.7z"/>
										</g>
									</g>
									<path className="st2 icon" d="M152.6,88c1.8,0,3.4-0.7,4.7-1.9c1.3-1.2,1.9-2.9,1.9-4.7c0-1.8-0.7-3.4-1.9-4.7c-1.1-1.1-2.4-1.7-3.9-1.9
										c-0.1-3-1.3-5.9-3.4-8.1c-2.2-2.2-5.2-3.4-8.3-3.4c0,0,0,0,0,0c-5.8,0-10.5,4.1-11.5,9.6c-0.2,0-0.3,0-0.5,0c0,0,0,0,0,0
										c-2.3,0-4.5,1.1-5.9,2.8l-4.7-6.9l-20.7,33.8L89,88.8l-4.5,6.7c-0.6-1.8-1.5-3.5-2.9-4.8c-2.2-2.2-5.2-3.4-8.3-3.4c0,0,0,0,0,0
										c-5.8,0-10.5,4.1-11.5,9.6c-3.1-0.2-6,1.6-7.3,4.4c-0.5,1-0.7,2.1-0.7,3.1c0,2,0.8,3.9,2.2,5.3c1.4,1.4,3.3,2.2,5.3,2.2l12.1,0
										l-19.4,28.6l2.5,1.7l21.4-31.5l6.5,6.5l4.7-5.8l4.7,5.8l6.5-6.5l21.5,31.8l2.5-1.7l-24-35.4l8-13.1l6.2,6.2l4.7-5.8l4.7,5.8l7-7
										l21.3,31.4l2.5-1.7L132,88L152.6,88C152.6,88,152.6,88,152.6,88z M61.2,108.9c-1.2,0-2.3-0.5-3.2-1.3c-0.8-0.8-1.3-2-1.3-3.2
										c0-0.6,0.1-1.3,0.4-1.9c0.7-1.6,2.3-2.6,4.1-2.6c0.4,0,0.8,0.1,1.4,0.2l1.9,0.6l0.1-2c0.1-4.7,3.9-8.4,8.7-8.4c0,0,0,0,0,0
										c2.3,0,4.5,0.9,6.1,2.5c1.6,1.6,2.5,3.8,2.5,6.1c0,0.1,0,0.2,0,0.3l-6.5,9.6L61.2,108.9z M93.9,112.7l-4.9-6.1l-4.9,6.1l-4.3-4.3
										l-0.9,0.9l5.9-8.7l0.1,0c0-0.1,0-0.1,0-0.2l4.1-6.1l9.4,13.9L93.9,112.7z M128.9,89.1L124,94l-4.9-6.1l-4.9,6.1l-4.3-4.3l0,0
										l9.3-15.2l10.3,15.2L128.9,89.1z M125.6,78.4c0.8-1.5,2.3-2.5,4-2.5c0,0,0,0,0,0c0.4,0,0.9,0.1,1.4,0.2l1.9,0.6l0.1-2
										c0.1-4.7,3.9-8.4,8.7-8.4c0,0,0,0,0,0c2.3,0,4.5,0.9,6.1,2.5s2.5,3.8,2.5,6.1c0,0.4,0,0.8-0.1,1.1l-0.3,2.1l2.1-0.4
										c0.2,0,0.4-0.1,0.6-0.1c2,0,3.5,1.6,3.5,3.5c0,0.9-0.4,1.8-1,2.5c-0.7,0.7-1.6,1-2.5,1c0,0,0,0,0,0l-22.6,0L125.6,78.4z"/>
								</g>
							</svg>

                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">PJM’s all-time winter peak of about <span className="text--yellow">143,295 MW</span> was set on Feb.&nbsp;20,&nbsp;2015.</div>
            				</div>
                		</div>
                	</div>
                	<div ref={(element) => {accordionItem.current[1] = element}} className="accordion__item">
                		<div onClick={() => {handleClickAccordion(1)}} className="accordion__trigger">
                			<svg 
                				ref={(element) => {triggers.current[1] = element}}
                				version="1.1" 
                				id="winter-trigger-2" 
                				xmlns="http://www.w3.org/2000/svg" 
                				xmlnsXlink="http://www.w3.org/1999/xlink" 
                				x="0px" 
                				y="0px"	
                				viewBox="0 0 206.1 213.3" 
                				style={{enableBackground:"new 0 0 206.1 213.3"}} 
                				xmlSpace="preserve">
								<g id="Layer_1_00000142138281924354524630000003232575756329348532_">
								</g>
								<g className="summer-circle-item">
									<linearGradient id="winter-trigger2" gradientUnits="userSpaceOnUse" x1="44.4619" y1="35.6944" x2="163.5624" y2="182.0698">
										<stop  offset="0" style={{stopColor:"#7FBD1D"}}/>
										<stop  offset="2.708180e-04" style={{stopColor:"#7FBD1D"}}/>
										<stop  offset="0.2524" style={{stopColor:"#82BD1C"}}/>
										<stop  offset="0.424" style={{stopColor:"#8BBD1A"}}/>
										<stop  offset="0.5717" style={{stopColor:"#9ABD17"}}/>
										<stop  offset="0.7059" style={{stopColor:"#B0BE12"}}/>
										<stop  offset="0.8309" style={{stopColor:"#CBBE0C"}}/>
										<stop  offset="0.9476" style={{stopColor:"#EDBF04"}}/>
										<stop  offset="0.9997" style={{stopColor:"#FFBF00"}}/>
										<stop  offset="1" style={{stopColor:"#FFBF00"}}/>
									</linearGradient>
									<circle style={{fill: "url(#winter-trigger2)"}} className="st0 summer-circle" cx="102.6" cy="107.2" r="90"/>
									<rect x="59.3" y="138.6" className="st1" width="88" height="39.9"/>
									<g className="icon-text">
										<text transform="matrix(1 0 0 1 64.6055 152.5521)"><tspan x="0" y="0" className="st2 st3 st4">177,000 </tspan><tspan x="19.8" y="20.9" className="st2 st3 st4">MW</tspan></text>
									</g>
									<g className="rings">
										<g id="Group-5_00000087377334140574249740000006477068703698483361_" transform="translate(-3.000000, -3.000000)">
											<path id="Stroke-1_00000034780605130689364790000002607366798409800121_" className="st5" d="M106,3.8C49.1,3.8,3,50,3,106.9
												s46.1,103,103,103c56.9,0,103-46.1,103-103S162.9,3.8,106,3.8z M106,6.8c55.3,0,100.1,44.8,100.1,100.1S161.3,207,106,207
												C50.7,207,5.9,162.2,5.9,106.9S50.7,6.8,106,6.8z"/>
											<path id="Stroke-3_00000085931929955083584170000000671874124830396814_" className="st6" d="M106,11.1c-56.9,0-103,46.1-103,103
												s46.1,103,103,103c56.9,0,103-46.1,103-103S162.9,11.1,106,11.1z M106,14c55.3,0,100.1,44.8,100.1,100.1S161.3,214.2,106,214.2
												c-55.3,0-100.1-44.8-100.1-100.1S50.7,14,106,14z"/>
										</g>
									</g>
									<g className="icon">
										<path className="st2" d="M85.2,86.1l8.5,4.9c0.2,0.1,0.5,0.2,0.7,0.2s0.5-0.1,0.7-0.2c0.4-0.3,0.7-0.7,0.7-1.3l0-9.8
											c0-0.5-0.3-1-0.7-1.3l-8.5-4.9c0,0-0.1-0.1-0.2-0.1c-0.7-0.3-1.5,0-1.9,0.7c-0.1,0.3-0.2,0.5-0.1,0.8v9.7
											C84.5,85.4,84.8,85.9,85.2,86.1z M87.4,77.6l5.6,3.2l0,6.5L87.4,84V77.6z M68.4,105.8l8.4,4.8c0.2,0.1,0.5,0.2,0.7,0.2
											s0.5-0.1,0.7-0.2l8.5-4.9c0.4-0.3,0.7-0.7,0.7-1.3c0-0.5-0.3-1-0.7-1.3l-8.5-4.9c-0.4-0.3-1-0.3-1.4,0l-8.5,4.9
											c0,0-0.1,0.1-0.1,0.1c-0.6,0.4-0.8,1.3-0.4,2C67.9,105.6,68.1,105.7,68.4,105.8z M77.5,101.3l5.6,3.2l-5.6,3.2l-5.6-3.2L77.5,101.3
											z M95.9,129.1v-9.8c0-0.5-0.3-1-0.7-1.3c-0.4-0.3-1-0.3-1.4,0l-8.5,4.9c-0.4,0.3-0.7,0.7-0.7,1.3v9.8c0,0,0,0,0,0
											c0,0.8,0.6,1.4,1.4,1.4c0.3,0,0.6-0.1,0.8-0.3l8.4-4.8C95.6,130.1,95.9,129.6,95.9,129.1z M93,128.2l-5.6,3.2V125l5.6-3.2V128.2z
											 M120.7,122.9l-8.5-4.9c-0.4-0.3-1-0.3-1.4,0c-0.4,0.3-0.7,0.7-0.7,1.3l0,9.8c0,0.5,0.3,1,0.7,1.3l8.5,4.9c0.2,0.1,0.5,0.2,0.7,0.2
											c0.5,0,1-0.2,1.2-0.7c0.2-0.3,0.2-0.6,0.2-0.8v-9.7C121.4,123.6,121.2,123.2,120.7,122.9z M118.5,131.5l-5.6-3.2l0-6.5l5.6,3.2
											V131.5z M137.6,103.2l-8.4-4.9c-0.4-0.3-1-0.3-1.4,0l-8.5,4.9c-0.4,0.3-0.7,0.7-0.7,1.3c0,0.5,0.3,1,0.7,1.3l8.5,4.9
											c0.2,0.1,0.5,0.2,0.7,0.2c0.2,0,0.5-0.1,0.7-0.2l8.5-4.9c0.7-0.4,0.9-1.2,0.6-1.9C138.2,103.6,137.9,103.4,137.6,103.2z
											 M128.5,107.7l-5.6-3.2l5.6-3.2l5.6,3.2L128.5,107.7z M110,80l0,9.8c0,0.5,0.3,1,0.7,1.3c0.2,0.1,0.5,0.2,0.7,0.2s0.5-0.1,0.7-0.2
											l8.5-4.9c0.4-0.3,0.7-0.7,0.7-1.3l0-9.8c0-0.7-0.6-1.4-1.3-1.4c-0.3,0-0.7,0.1-0.9,0.2l-8.4,4.9C110.3,79,110,79.5,110,80z
											 M118.5,77.6l0,6.5l-5.6,3.2l0-6.5L118.5,77.6z M141.8,115.3l-8.6,5l6.3,3.7l-1.4,2.5l-6.3-3.7l0,9.9h-2.9l0-11.6L104.4,107v28.2
											l10,5.8l-1.4,2.5l-8.6-5v7.3h-2.9v-7.3l-8.6,5l-1.4-2.5l10.1-5.8V107l-24.4,14.1v11.6h-2.9v-9.9l-6.3,3.6l-1.4-2.5l6.3-3.7l-8.6-5
											l1.4-2.5l10.1,5.8l24.4-14.1L75.7,90.4l-10,5.8l-1.4-2.5l8.6-5l-6.3-3.6l1.4-2.5l6.3,3.7v-9.9h2.9v11.6l24.4,14.1V73.8l-10-5.8
											l1.4-2.5l8.6,5v-7.3h2.9v7.3l8.6-5l1.4,2.5l-10.1,5.8V102l24.4-14.1V76.3h2.9v9.9l6.3-3.7l1.4,2.5l-6.3,3.7l8.6,5l-1.4,2.5
											l-10.1-5.8l-24.4,14.1l24.4,14.1l10-5.8L141.8,115.3z"/>
									</g>
								</g>
							</svg>


                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">PJM's 2020/2021 winter peak was approximately <span className="text--yellow">117,000 MW</span>.</div>
            				</div>
                		</div>
                	</div>
                	<div ref={(element) => {accordionItem.current[2] = element}} className="accordion__item">
                		<div onClick={() => {handleClickAccordion(2)}} className="accordion__trigger">
							<svg 
								ref={(element) => {triggers.current[2] = element}}
								version="1.1" 
								id="winter-trigger-3" 
								xmlns="http://www.w3.org/2000/svg" 
								xmlnsXlink="http://www.w3.org/1999/xlink" 
								x="0px" 
								y="0px"
								viewBox="0 0 206.6 213.9" 
								style={{enableBackground:"new 0 0 206.6 213.9"}} 
								xmlSpace="preserve">
								<g id="Layer_1_00000128447528328039966230000018063964001819027334_">
								</g>
								<g className="summer-circle-item">
									<linearGradient id="winter-trigger3" gradientUnits="userSpaceOnUse" x1="56.8823" y1="51.1483" x2="199.5394" y2="226.4751">
										<stop  offset="0" style={{stopColor:"#FA0089"}}/>
										<stop  offset="1.000839e-02" style={{stopColor:"#F7038A"}}/>
										<stop  offset="0.2063" style={{stopColor:"#C13DA5"}}/>
										<stop  offset="0.3962" style={{stopColor:"#936DBC"}}/>
										<stop  offset="0.5751" style={{stopColor:"#7092CD"}}/>
										<stop  offset="0.7404" style={{stopColor:"#57ADDA"}}/>
										<stop  offset="0.887" style={{stopColor:"#47BDE1"}}/>
										<stop  offset="1" style={{stopColor:"#42C3E4"}}/>
									</linearGradient>
									<circle style={{fill: "url(#winter-trigger3)"}} className="st0 summer-circle" cx="102.7" cy="107.4" r="90"/>
									<g className="icon">
										<path className="st1" d="M109.3,143H73.6c-5.2,0-9.5-4.3-9.5-9.5V74.3c0-5.2,4.3-9.5,9.5-9.5h10v3.1h-10c-3.5,0-6.4,2.9-6.4,6.4v59.2
											c0,3.5,2.9,6.4,6.4,6.4h35.7V143z"/>
										<path className="st1" d="M142.2,110.1h-3.1V74.3c0-3.5-2.9-6.4-6.4-6.4h-10v-3.1h10c5.2,0,9.5,4.3,9.5,9.5V110.1z"/>
										<rect x="120.1" y="119.3" className="st1" width="9.8" height="3.1"/>
										<rect x="83.6" y="64.9" className="st1" width="39.1" height="3.1"/>
										<path className="st1" d="M109.3,143v-3.1c5.1,0,9.3-4.2,9.3-9.3v-11.3h11.3c5.1,0,9.3-4.2,9.3-9.3h3.1c0,6.8-5.5,12.3-12.3,12.3h-8.2
											v8.2C121.6,137.4,116.1,143,109.3,143z"/>
										<path className="st1" d="M109.3,143v-3.1c16.5,0,29.9-13.4,29.9-29.9h3.1C142.2,128.2,127.4,143,109.3,143z"/>
										<rect x="65.6" y="85.6" className="st1" width="64" height="3.1"/>
										<rect x="82.1" y="60.9" className="st1" width="3.1" height="10.5"/>
										<rect x="121.2" y="60.9" className="st1" width="3.1" height="10.5"/>
										<path className="st1" d="M85.5,111.4h-7.3c-2.3,0-4.1-1.8-4.1-4.1V100c0-2.3,1.8-4.1,4.1-4.1h7.3c2.3,0,4.1,1.9,4.1,4.1v7.3
											C89.7,109.6,87.8,111.4,85.5,111.4z M78.2,98.9c-0.6,0-1.1,0.5-1.1,1.1v7.3c0,0.6,0.5,1.1,1.1,1.1h7.3c0.6,0,1.1-0.5,1.1-1.1V100
											c0-0.6-0.5-1.1-1.1-1.1H78.2z"/>
										<path className="st1" d="M106.8,111.4h-7.3c-2.3,0-4.1-1.8-4.1-4.1V100c0-2.3,1.8-4.1,4.1-4.1h7.3c2.3,0,4.1,1.9,4.1,4.1v7.3
											C110.9,109.6,109.1,111.4,106.8,111.4z M99.5,98.9c-0.6,0-1.1,0.5-1.1,1.1v7.3c0,0.6,0.5,1.1,1.1,1.1h7.3c0.6,0,1.1-0.5,1.1-1.1
											V100c0-0.6-0.5-1.1-1.1-1.1H99.5z"/>
										<path className="st1" d="M85.5,132.7h-7.3c-2.3,0-4.1-1.8-4.1-4.1v-7.3c0-2.3,1.8-4.1,4.1-4.1h7.3c2.3,0,4.1,1.8,4.1,4.1v7.3
											C89.7,130.8,87.8,132.7,85.5,132.7z M78.2,120.2c-0.6,0-1.1,0.5-1.1,1.1v7.3c0,0.6,0.5,1.1,1.1,1.1h7.3c0.6,0,1.1-0.5,1.1-1.1
											v-7.3c0-0.6-0.5-1.1-1.1-1.1H78.2z"/>
										<path className="st1" d="M106.8,132.7h-7.3c-2.3,0-4.1-1.8-4.1-4.1v-7.3c0-2.3,1.8-4.1,4.1-4.1h7.3c2.3,0,4.1,1.8,4.1,4.1v7.3
											C110.9,130.8,109.1,132.7,106.8,132.7z M99.5,120.2c-0.6,0-1.1,0.5-1.1,1.1v7.3c0,0.6,0.5,1.1,1.1,1.1h7.3c0.6,0,1.1-0.5,1.1-1.1
											v-7.3c0-0.6-0.5-1.1-1.1-1.1H99.5z"/>
										<path className="st1" d="M128,111.4h-7.3c-2.3,0-4.1-1.8-4.1-4.1V100c0-2.3,1.8-4.1,4.1-4.1h7.3c2.3,0,4.1,1.9,4.1,4.1v7.3
											C132.2,109.6,130.3,111.4,128,111.4z M120.7,98.9c-0.6,0-1.1,0.5-1.1,1.1v7.3c0,0.6,0.5,1.1,1.1,1.1h7.3c0.6,0,1.1-0.5,1.1-1.1
											V100c0-0.6-0.5-1.1-1.1-1.1H120.7z"/>
									</g>
									<g className="icon-text">
										<rect x="61.4" y="140.9" className="st2" width="88" height="39.9"/>
										<text transform="matrix(1 0 0 1 83.2517 154.8314)"><tspan x="0" y="0" className="st1 st3 st4">FEB. </tspan><tspan x="-15.5" y="20.9" className="st1 st3 st4">FREEZE</tspan></text>
									</g>
									<g className="rings">
										<g id="Group-5_00000067236835430330900580000003013499138583296185_" transform="translate(-3.000000, -3.000000)">
											<path id="Stroke-1_00000152242964694896135600000010987488885958693275_" className="st5" d="M106,3.6C48.9,3.6,2.7,49.8,2.7,106.9
												S48.9,210.2,106,210.2c57.1,0,103.3-46.3,103.3-103.3S163.1,3.6,106,3.6z M106,6.5c55.4,0,100.4,45,100.4,100.4
												s-45,100.4-100.4,100.4c-55.4,0-100.4-45-100.4-100.4S50.6,6.5,106,6.5z"/>
											<path id="Stroke-3_00000096053779458138156560000012882522507988659351_" className="st6" d="M106,10.8C48.9,10.8,2.7,57.1,2.7,114.1
												S48.9,217.4,106,217.4c57.1,0,103.3-46.3,103.3-103.3S163.1,10.8,106,10.8z M106,13.7c55.4,0,100.4,45,100.4,100.4
												s-45,100.4-100.4,100.4c-55.4,0-100.4-45-100.4-100.4S50.6,13.7,106,13.7z"/>
										</g>
									</g>
								</g>
							</svg>


                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">To support neighboring systems during the "February Freeze" event of 2021, PJM exported a high of <span className="text--yellow">15,700 MW</span>, more than doubling the amount of exports on a typical day. As the 2021/2022 winter approached, PJM had more than <span className="text--yellow">185,000 MW</span> of available resources.</div>
            				</div>
                		</div>
                	</div>
                	<div ref={(element) => {accordionItem.current[3] = element}} className="accordion__item">
                		<div onClick={() => {handleClickAccordion(3)}} className="accordion__trigger">
                			<svg 
                				ref={(element) => {triggers.current[3] = element}}
                				version="1.1" 
                				id="winter-trigger-4" 
                				xmlns="http://www.w3.org/2000/svg" 
                				xmlnsXlink="http://www.w3.org/1999/xlink" 
                				x="0px" 
                				y="0px" 
                				viewBox="0 0 208.7 216" 
                				style={{enableBackground:"new 0 0 208.7 216"}} 
                				xmlSpace="preserve">
	                			<g id="Layer_1_00000110460172416180494810000013042351771973706380_">
	                			</g>
	                			<g>
	                				<g className="summer-circle-item">
	                					<linearGradient id="winter-trigger4" gradientUnits="userSpaceOnUse" x1="70.2054" y1="67.4458" x2="225.4968" y2="258.3">
	                						<stop  offset="0" style={{stopColor:"#FFC000"}}/>
	                						<stop  offset="0.1129" style={{stopColor:"#FEB906"}}/>
	                						<stop  offset="0.2803" style={{stopColor:"#FAA515"}}/>
	                						<stop  offset="0.4816" style={{stopColor:"#F5842E"}}/>
	                						<stop  offset="0.7093" style={{stopColor:"#ED5651"}}/>
	                						<stop  offset="0.9561" style={{stopColor:"#E41C7D"}}/>
	                						<stop  offset="1" style={{stopColor:"#E21185"}}/>
	                					</linearGradient>
	                					<circle style={{fill: "url(#winter-trigger4)"}} className="st0 summer-circle" cx="104.4" cy="109.4" r="90"/>
	                				</g>
	                				<g>
	                					<g className="rings">
	                						<g id="Group-5_00000138551671860782389000000000783816597511084708_" transform="translate(-3.000000, -3.000000)">
	                							<path id="Stroke-1_00000037688457803182190910000004306801305799047839_" className="st1" d="M107,3.5C49.4,3.5,2.7,50.2,2.7,107.8
	                								S49.4,212.2,107,212.2c57.6,0,104.3-46.7,104.3-104.3S164.6,3.5,107,3.5z M107,6.4c56,0,101.4,45.4,101.4,101.4
	                								S163,209.2,107,209.2c-56,0-101.4-45.4-101.4-101.4S51,6.4,107,6.4z"/>
	                							<path id="Stroke-3_00000150100656095122174380000014061890064015105690_" className="st2" d="M107,10.8
	                								C49.4,10.8,2.7,57.5,2.7,115.2S49.4,219.5,107,219.5c57.6,0,104.3-46.7,104.3-104.3S164.6,10.8,107,10.8z M107,13.8
	                								c56,0,101.4,45.4,101.4,101.4S163,216.6,107,216.6c-56,0-101.4-45.4-101.4-101.4S51,13.8,107,13.8z"/>
	                						</g>
	                					</g>
	                					<g className="icon">
		                					<path className="st3" d="M70.6,86.9l12.4,0l0.1,0c2.4-0.4,4.3-2.6,4.3-5.3c0-3-2.4-5.4-5.4-5.5c-0.8-2-2.8-3.3-5-3.3
		                						c-2.2,0-4.2,1.4-5,3.3c-3-0.1-5.6,2.4-5.6,5.5C66.3,84.3,68.2,86.6,70.6,86.9z M71.8,78.9c0.2,0,0.4,0,0.7,0.1l1.6,0.4l0.2-1.6
		                						c0.2-1.3,1.3-2.3,2.6-2.3c1.3,0,2.4,1,2.6,2.3l0.2,1.5l1.5-0.4c0.2-0.1,0.4-0.1,0.6-0.1c1.5,0,2.7,1.2,2.7,2.7
		                						c0,1.2-0.8,2.3-1.8,2.5H70.9c-1-0.2-1.7-1.3-1.7-2.5C69.2,80.1,70.4,78.9,71.8,78.9z M124.3,87.7c2.3,0,4.2,1.3,5,3.3
		                						c3,0,5.4,2.5,5.4,5.5H132c0-1.5-1.2-2.7-2.7-2.7c-0.2,0-0.4,0-0.6,0.1l-1.5,0.4l-0.2-1.5c-0.2-1.3-1.3-2.3-2.6-2.3
		                						c-1.3,0-2.4,1-2.6,2.3l-0.2,1.6l-1.6-0.4c-0.3-0.1-0.5-0.1-0.7-0.1c-1.5,0-2.7,1.2-2.7,2.7c0,1.2,0.8,2.4,1.7,2.5h12v2.8l-12.3,0
		                						c-2.4-0.3-4.2-2.6-4.2-5.3c0-3,2.5-5.5,5.5-5.5c0,0,0.1,0,0.1,0C120.1,89.1,122.1,87.7,124.3,87.7z M130.6,142.1V115l10.3,14
		                						l2.3-1.7l-12.3-16.7l11.3-17.4l-2.4-1.5l-11.4,17.6l-8.8,0.2l0.1,2.8l8.1-0.2v29.9h-22.3l-1-31.1l9.2,12.5l7.6-0.2L110.3,102
		                						l-6.5-4L120.7,72l-2.9-7l-16,17.7l-1.4,7.5c-0.3-0.1-0.7-0.1-1-0.1c0,0-0.1,0-0.1,0v0l-31.1,0.3l-4.3,6.3l23.6,3.6l7.1-2.9
		                						c0.1,0.2,0.2,0.4,0.3,0.7l-1.5,44.2H80.7v-18.3l6.9,9.3l2.3-1.7l-8.8-12l8.1-12.5l-2.4-1.5l-8.2,12.7l-15.1,0.1l0,2.8l14.4-0.1
		                						v21.1h-14v2.8h79.6v-2.8H130.6z M129.2,110.7L129.2,110.7L129.2,110.7L129.2,110.7z M79.3,119.5L79.3,119.5L79.3,119.5L79.3,119.5
		                						z M116.7,120.6l-1.7,0l-14.9-20.2c0.5-0.1,1-0.2,1.4-0.4l6.6,4L116.7,120.6z M104.5,84l12.4-13.8l0.6,1.5l-13.6,21.1
		                						c-0.2-0.4-0.5-0.8-0.9-1.2L104.5,84z M101.8,95.3c0,1.3-1.1,2.4-2.4,2.4S97,96.6,97,95.3s1.1-2.4,2.4-2.4S101.8,94,101.8,95.3z
		                						 M87.2,97.3l-18.4-2.8l0.9-1.4l25.1-0.2c-0.2,0.4-0.4,0.9-0.5,1.4L87.2,97.3z M97.6,101.6l3.9,5.3l1.1,35.1h-6.4L97.6,101.6z"/>
	                					</g>
	                					<g className="icon-text">
		                					<rect x="61" y="146.2" className="st4" width="88" height="39.9"/>
		                					<text transform="matrix(1 0 0 1 65.391 160.1755)"><tspan x="0" y="0" className="st3 st5 st6">169,682</tspan><tspan x="20.7" y="20.9" className="st3 st5 st6">MW</tspan></text>
		                				</g>
	                				</g>
	                			</g>
                			</svg>

                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text"><span className="text--yellow">169,682 MW</span> of estimated available generation represented committed capacity resources.</div>
            				</div>
                		</div>
                	</div>
                	<div ref={(element) => {accordionItem.current[4] = element}} className="accordion__item">
                		<div onClick={() => {handleClickAccordion(4)}} className="accordion__trigger">
							<svg 
								ref={(element) => {triggers.current[4] = element}}
								version="1.1" 
								id="winter-trigger-5" 
								xmlns="http://www.w3.org/2000/svg" 
								xmlnsXlink="http://www.w3.org/1999/xlink" 
								x="0px" 
								y="0px" 
								viewBox="0 0 208.8 216.1" 
								style={{enableBackground:"new 0 0 208.8 216.1"}} 
								xmlSpace="preserve">
								<g id="Layer_1_00000151515517250586371760000017314939112229132948_">
								</g>
								<g className="summer-circle-item">
									<linearGradient id="winter-trigger5" gradientUnits="userSpaceOnUse" x1="59.3004" y1="51.8785" x2="178.4008" y2="198.2538">
										<stop  offset="0" style={{stopColor:"#42C3E4"}}/>
										<stop  offset="0.1714" style={{stopColor:"#42C3E4"}}/>
										<stop  offset="0.2633" style={{stopColor:"#44C3DE"}}/>
										<stop  offset="0.3836" style={{stopColor:"#49C2CE"}}/>
										<stop  offset="0.5195" style={{stopColor:"#51C2B3"}}/>
										<stop  offset="0.6669" style={{stopColor:"#5DC08D"}}/>
										<stop  offset="0.8236" style={{stopColor:"#6BBF5D"}}/>
										<stop  offset="0.9859" style={{stopColor:"#7DBD22"}}/>
										<stop  offset="1" style={{stopColor:"#7FBD1D"}}/>
									</linearGradient>
									<circle style={{fill: "url(#winter-trigger5)"}} className="st0 summer-circle" cx="105.1" cy="108.2" r="90"/>
									<g className="icon-text">
										<rect x="59.8" y="144.9" className="st1" width="88" height="39.9"/>
										<text transform="matrix(1 0 0 1 64.2342 158.8194)"><tspan x="0" y="0" className="st2 st3 st4">133,000 </tspan><tspan x="20.7" y="20.9" className="st2 st3 st4">MW</tspan></text>
									</g>
									<g className="rings">
										<g id="Group-5_00000160160091058501129440000014666595447837358211_" transform="translate(-3.000000, -3.000000)">
											<path id="Stroke-1_00000065065729802669512880000010433733351611571866_" className="st5" d="M107.6,3C49.9,3,3.1,49.8,3.1,107.4
												s46.7,104.4,104.4,104.4c57.7,0,104.4-46.7,104.4-104.4S165.2,3,107.6,3z M107.6,6C163.6,6,209,51.4,209,107.4
												s-45.4,101.5-101.5,101.5c-56,0-101.5-45.4-101.5-101.5S51.5,6,107.6,6z"/>
											<path id="Stroke-3_00000178889901210901811270000002682865984729798844_" className="st6" d="M107.6,10.4
												C49.9,10.4,3.1,57.1,3.1,114.8s46.7,104.4,104.4,104.4c57.7,0,104.4-46.7,104.4-104.4S165.2,10.4,107.6,10.4z M107.6,13.3
												c56,0,101.5,45.4,101.5,101.5s-45.4,101.5-101.5,101.5c-56,0-101.5-45.4-101.5-101.5S51.5,13.3,107.6,13.3z"/>
										</g>
									</g>
									<g className="icon">
										<path className="st2" d="M66.7,118.9c-1.9-4.8-2.9-9.9-2.9-15.1c0-5.2,1-10.3,2.9-15.1c1.9-4.6,4.5-8.8,7.9-12.3
											c3.4-3.6,7.3-6.4,11.6-8.3l1.3-0.6l-2-5.1l16.8,2.5L92,78.9L90.2,74l-1.4,0.6c-3.6,1.6-6.8,3.9-9.5,6.8c-2.7,2.9-4.9,6.3-6.4,10
											c-1.6,3.9-2.3,8-2.3,12.3s0.8,8.4,2.3,12.3c0.9,2.3,2.1,4.5,3.5,6.5l2.4-1.7c-1.3-1.8-2.4-3.8-3.2-5.9c-1.4-3.5-2.1-7.3-2.1-11.2
											s0.7-7.6,2.1-11.2c1.4-3.4,3.3-6.5,5.8-9.1c2.1-2.2,4.5-4.1,7.2-5.5l2.1,5.8l1.9-0.8l14.8-20.3l-24.1-3.6l-1.9,0.8l2.4,6
											c-4.2,2.1-8,4.9-11.3,8.4c-3.6,3.8-6.5,8.3-8.5,13.3c-2.1,5.1-3.1,10.6-3.1,16.2c0,5.6,1,11.1,3.1,16.2c0.7,1.7,1.5,3.4,2.4,5
											l2.5-1.4C68.1,122.1,67.3,120.5,66.7,118.9z"/>
										<path className="st2" d="M128.2,134.9c-4,3.4-8.5,6-13.4,7.7c-4.7,1.6-9.6,2.3-14.5,2.1c-4.9-0.2-9.6-1.4-13.9-3.4l-1.3-0.6l-2.5,4.8
											l-9-14.4l17.3-1.4l-2.5,4.5l1.4,0.7c3.5,1.7,7.3,2.6,11.3,2.8c4,0.2,7.9-0.4,11.8-1.7c4-1.3,7.6-3.4,10.8-6.2
											c3.2-2.8,5.8-6,7.8-9.7l-2.6-1.3c-1.8,3.4-4.2,6.4-7.1,8.9c-2.9,2.5-6.3,4.4-9.9,5.7c-3.5,1.2-7.1,1.7-10.7,1.5
											c-3.1-0.2-6-0.8-8.8-1.9l3-5.4l-1.9-0.9l-25,2l12.9,20.6l1.9,0.9l3-5.7c4.3,1.9,8.9,2.9,13.7,3.1c5.3,0.3,10.5-0.5,15.6-2.2
											c5.2-1.8,10.1-4.5,14.3-8.2c3.1-2.7,5.8-5.7,8-9l-2.4-1.6C133.7,129.6,131.1,132.4,128.2,134.9z"/>
										<path className="st2" d="M152.6,101.7l-6.5-0.1c-0.3-4.7-1.4-9.3-3.3-13.7c-2.1-4.8-5.1-9.2-8.9-12.9c-3.9-3.9-8.6-7-13.7-9.2
											c-2.5-1.1-5.1-1.9-7.7-2.5l-0.6,2.8c2.4,0.5,4.9,1.3,7.2,2.3c4.8,2,9.1,4.9,12.8,8.6c3.5,3.5,6.3,7.6,8.3,12.1c2,4.5,3,9.2,3.1,14
											l0,1.4l5.5,0.1l-8.9,14.5l-9-14.9l5.2,0.2l0-1.5c-0.1-3.9-0.9-7.7-2.5-11.4c-1.6-3.7-3.9-6.9-6.7-9.8c-3-2.9-6.5-5.3-10.4-6.9
											c-3-1.3-6.2-2.1-9.4-2.4l-0.3,2.9c2.9,0.3,5.8,1.1,8.6,2.2c3.6,1.5,6.8,3.6,9.5,6.3c2.6,2.6,4.7,5.6,6.1,8.9
											c1.2,2.8,2,5.8,2.2,8.7l-6.2-0.3l0,2.1l12.9,21.5l12.7-20.8L152.6,101.7z"/>
										<path className="st2" d="M106.3,84.5l-18.2,24.3h12.7l-6.2,15.3h5l17.7-24.3h-12.6l6.8-15.3H106.3z M100.3,102.7h11.4L99.8,119l5.3-13
											H93.9L106,89.7L100.3,102.7z"/>
									</g>
								</g>
							</svg>



                		</div>
                		<div className="accordion__content">
                			<div className="speech-bubble">
                				<div className="text">For the 2021/2022 winter, PJM forecasted a peak winter demand of about <span className="text--yellow">133,000 MW</span>.</div>
            				</div>
                		</div>
                	</div>

                </div>
            </div>
	    </div>
	)
}